export type CadRendererPlaceholderProps = {
	message?: string | undefined;
};

export function CadRendererPlaceholder({ message }: CadRendererPlaceholderProps) {
	return (
		<div className='flex h-full w-full flex-col items-center justify-center gap-1 p-2 text-center'>
			<p className='mb-2 font-semibold text-gray-a10'>No design selected</p>
			<p className='text-gray-a7'>{message ?? 'Select a sheet from the dropdown above to view the schematic'}</p>
		</div>
	);
}
